{
  "Accessibility menu": "Menu prístupnosti",
  "Close": "Zavrieť",
  "Content adjustments": "Úpravy obsahu",
  "Navigation adjustments": "Úpravy navigácie",
  "Align Left": "Zarovnať doľava",
  "Adjust Font Size": "Upraviť veľkosť písma",
  "Highlight Title": "Zvýrazniť nadpis",
  "Highlight Links": "Zvýrazniť odkazy",
  "Readable Font": "Čitateľné písmo",
  "Colour adjustments": "Úpravy farieb",
  "Dark Contrast": "Tmavý kontrast",
  "Light Contrast": "Svetlý kontrast",
  "High Contrast": "Vysoký kontrast",
  "High Saturation": "Vysoká sýtosť",
  "Low Saturation": "Nízka sýtosť",
  "Monochrome": "Monochróm",
  "Tools": "Nástroje",
  "Reading Guide": "Čítačský sprievodca",
  "Big Cursor": "Veľký kurzor",
  "Increase Font Size": "Zväčšiť písmo",
  "Decrease Font Size": "Zmenšiť písmo",
  "Letter Spacing": "Medzera medzi písmenami",
  "Line Height": "Výška riadku",
  "Font Weight": "Hrúbka písma",
  "Dyslexia Font": "Písmo pre dyslexiu",
  "Language": "Jazyk",
  "Accessibility widget": "Otvoriť menu prístupnosti",
  "Accessibility Profiles": "Profil prístupnosti",
  "Cognitive Disability": "Kognitívne postihnutie",
  "Seizure Safe": "Bezpečné pre záchvaty",
  "Accessibility statement": "Vyhlásenie o prístupnosti",
  "ADHD": "ADHD",
  "Low Vision": "Low Vision",
  "Pause Animations": "Zastaviť animácie",
  "Reset all settings": "Obnoviť nastavenia",
  "Shortcut:": "Shortcut:"
}
